import React, { Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import { Paper, Snackbar, Table } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import MainCard from './../MainCard';
import {Grid } from '@material-ui/core';
import axios from "../../../components/axios";
import MuiAlert from '@mui/material/Alert';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';



const StickyHeadCombineRowTable = ({ rows, columns, handleDownload, handleRedirect, exportURL, fullQuery, showSummary,  handleSummary, showShare, handleRelease, showRelease, shareAPI, handleDelete }) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const styleExportButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "110px",
    height: "40px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "13px",
    marginBottom:'10px',
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExportData = () => {
      axios.post(exportURL,fullQuery,{withCredentials: true})
      .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'full_data.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleShareLink = () => {
    axios.post("/peloton/v1/automation/TOTAL/"+shareAPI,fullQuery,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          navigator.clipboard.writeText(response.data.url)
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
    setOpen(true)
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  return (
    <MainCard >
    <Grid container justifyContent="space-around" >
    { showShare && <Button aria-hidden style={styleExportButton} onClick={handleExportData}>Export Data</Button>}
    { showSummary && <Button aria-hidden style={styleExportButton} onClick={handleSummary}>Summary</Button>}
    { showShare && <Button aria-hidden style={styleExportButton} onClick={handleShareLink}>Share</Button>}
    { showRelease && <Button aria-hidden style={styleExportButton} onClick={handleRelease}>Release notes</Button>}
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
          Link copy to clipboard!
        </Alert>
      </Snackbar>
    </Grid>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
          <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={{ bgcolor: "#406599", color:"white" }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((item) => (
              <Fragment key={item.uuid}>
                <TableRow hover={true} key={item.uuid}>
                  <TableCell rowSpan={item.count.length + 1} key={item.build_number}>
                    {item.build_number}
                  </TableCell>
                  <TableCell rowSpan={item.count.length + 1} key={item.uuid + '_is2g'}>
                    {item.is_2G === 'y' ? '2G' : (item.is_2G === 'n' || item.is_2G === undefined ? '4G' : item.is_2G)}
                  </TableCell>
                  <TableCell rowSpan={item.count.length + 1} key={item.device_sn}>
                    {item.device_sn}
                  </TableCell>
                </TableRow>
                {item.count.map((detail, index) => (
                  <TableRow hover={true} key={detail.id}>
                    <TableCell>{detail.suite}</TableCell>
                    <TableCell>{detail.value}</TableCell>
                    <TableCell>{detail.value2}</TableCell>
                    <TableCell>{detail.value3}</TableCell>
                    <TableCell>{detail.value4}</TableCell>
                    <TableCell>{detail.value5}</TableCell>
                    <TableCell>{detail.average}</TableCell>
                    {index %2 === 0 && columns.some(c => c.ignore) && (<TableCell rowSpan={3} ><div><Button onClick={() => handleDelete(item)}><VisibilityOffIcon sx={{ color: "#406599",fontSize: 20 }}/></Button></div></TableCell>)}
                  </TableRow>
                ))}
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
    </MainCard>
  );
}

export default StickyHeadCombineRowTable;
